
import React from "react";
import { getVisaLinksFragment, teamEmail, officePhone, officeHours } from "../utils";
import { Link } from "@travellocal/ui";
import * as WebRoutes from "@travellocal/utils/webRoutes";

interface Props {
  lto: Pick<ILtoSummary, "name" | "slug">;
  itinerary: Pick<IItinerarySummary, "countries" | "primaryLocation">;
  enquiry: Pick<IEnquiry, "id">;
}

export const ItineraryNotesContent: React.FC<Props> = ({ enquiry, itinerary, lto }) => {
  return (
    <>
      <ul>
        <li>All services specified in this itinerary are subject to availability.</li>
        <li>TravelLocal acts as a disclosed agent for {lto.name}, with whom your arrangements are booked.</li>
        <li>
          If you or any of your travel companions have reduced mobility, or other unique travel requirements,{" "}
          then make sure that you let your local expert know so that they can tailor your holiday accordingly.
        </li>
        <li>
          Please check if you require a visa for {getVisaLinksFragment(itinerary)}.{" "}
          Full advice for British passport holders is{" "}
          <a href="https://www.gov.uk/foreign-travel-advice" target="_blank" rel="noreferrer">
            available on the UK Government website
          </a>.
        </li>
        <li>Many destinations and airlines require a minimum of six months passport validity.</li>
        <li>
          It&apos;s important to know your consumer rights. The rights you gain when booking with TravelLocal{" "}
          are covered in the following documents:{" "}
          <Link to={WebRoutes.termsAndConditions()}>TravelLocal Terms &amp; Conditions</Link>,{" "}
          <Link to={WebRoutes.customerEnquiryBookingTerms(enquiry.id)}>{lto.name} Terms &amp; Conditions</Link>,{" "}
          <Link to={WebRoutes.ltoPtr(lto.slug)}>Package Travel and Linked Travel Regulations 2018 (Schedule 2)</Link>
        </li>
      </ul>

      <p>
        If you have any questions or concerns, don&apos;t hesitate to contact the TravelLocal team.{" "}
        You can email us at {teamEmail}, or give us a call on {officePhone}. We&apos;re available {officeHours}.
      </p>
    </>
  );
}
